import React, { Component } from 'react'
import { navbar,Modal, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'
import  Sidebar from "./Sidebar";
import Fade from 'react-reveal/Fade';
import Popup from "reactjs-popup";
import { zoomInDown } from 'react-animations';
import { lightSpeedIn } from 'react-animations';
import Radium, {StyleRoot} from 'radium';

const styles = {
  zoomInDown: {
    animation: 'x 2s',
    animationName: Radium.keyframes(zoomInDown, 'zoomInDown')
  }
}

class TERANGA extends Component {
  constructor(props){
    super(props);
    this.state={
      SmShow:true
    };
    this.setSmShow=this.setSmShow.bind(this)
  }
  setSmShow(status){
    this.setState({SmShow:status})
  }
  render() {
    return (
    <div>



    <section className="inner-intro bg-image overlay-dark parallax parallax-background1 inner_page_background" style={{backgroundImage:'url("/assets/img/images/branding/pmg7.jpg")'}}>
            <div className="container">
                <div className="row title">
                    <h2 className="h2">Nos Produits</h2>
                    <div className="page-breadcrumb">
                        <a>Nos Produits</a>/<img src="/assets/img/logos/teranga.png" className="teranga_img"/>
                    </div>
                </div>
            </div>
        </section>   
   <section id="about" className="wow fadeIn">
            <div className="container filigrane page_info Teranga-Page">
                <div className=" row text-center inside_content">
                <div className="col-md-12">
                  <div className="">
                   
                    <h2> <b className="keywords"><img src="/assets/img/logos/teranga.png" className="teranga_img titre_pod"/></b></h2>
                   
                    <div className="row">
                      <div className="col-md-12">
                         <p><b className="keywords"><img src="/assets/img/logos/teranga.png" className="teranga_img"/></b>  est un amendement organique structurant du sol. Il est issu de la valorisation des matières d’origine végétales, animales et agro-industrielles</p>

                         <div className="row sol">
                          <div className="col-md-6">
                          <p><b>Notre amendement <b className="keywords"><img src="/assets/img/logos/teranga.png" className="teranga_img"/></b> est disponible</b></p>
                                <Fade left>
                                  <p><i className="fa fa-check-circle"></i>Green Agro Business propose des solutions <img src="/assets/img/logos/teranga.png" className="teranga_img"/> et <img src="/assets/img/logos/terangaplus.png" className="page_ter_plus"/> naturelles pour une agriculture saine et durable.</p>
                                      <p>Fabriquées et commercialisées au Sénégal, ces solutions s’alignent avec l’Etat du Sénégal dans la contribution du volet agricole du Plan Sénégal Emergent (PSE) et de l’auto-suffisance alimentaire.</p>
                                      <p>Green Agro Business est engagée dans une démarche qualité en phase avec les normes du Sénégal et de la CEDEAO afin de garantir une agriculture biologique et d’accompagner les producteurs dans l’amélioration de leurs rendements et la régénération des sols.</p>
                                      <p>Pour toute commande et demande d’informations merci de nous contacter au:</p>
                                      <p> Téléphone fixe :<b className="keywords"> + 221 33 825 74 44 </b></p>
                                  <p>Téléphone mobile :<b className="keywords">+221 76 013 88 88</b></p>
                                  <p>Email : <b className="keywords">contact@greenagrobusiness.com</b></p>
                                  <p>Site : <b className="keywords">www.greenagrobusiness.com</b></p>
                                  <p>Contact Niayes :<b className="keywords">+221 76 224 30 44</b></p>
                                  <p>Contact Nord :<b className="keywords">+221 76 224 30 45</b></p>
                                  <p>Green Agro Business Keur Moussa-Région de Thiès-SENEGAL</p>
                                </Fade>
                          </div>
                          <div className="col-md-6">
                          <Fade left>
                            <img src="/assets/img/images/branding/bat_sac_amendement.jpg" className="amendement_img"/>
                            </Fade>
                        </div>
    </div>









                         <div className="row sol">
                         <div className="col-md-7">
                          <p><b>Effets du <b className="keywords"><img src="/assets/img/logos/teranga.png" className="teranga_img"/></b> sur le sol :</b></p>
                                  
                                  <Fade left>
                                  <p><i className="fa fa-check-circle"></i>Reconstituer et entretenir le taux de matière organique (humus),</p>
                                  <p><i className="fa fa-check-circle"></i>Stimuler l’activité microbienne,</p>
                                  <p><i className="fa fa-check-circle"></i>Libérer des éléments fertilisants du sol,</p>
                                  <p><i className="fa fa-check-circle"></i>Préserver la fertilité naturelle et diminuer les risques de lessivage</p>
                                </Fade>
                          </div>
                          <div className="col-md-5">
                            <Fade left>
                            <img src="/assets/img/images/branding/pmg7.jpg" className="images_sol"/>
                            </Fade>
                        </div>
                          </div>


                          <div className="row sol">
                          <div className="col-md-5">
                            <Fade right>
                            <img src="/assets/img/images/branding/pmg3.jpg" className="images_sol"/>
                            </Fade>
                        </div>
                         <div className="col-md-7">
                                  
                                <Fade left>
                                <p className=" titre_teranga"><b>Effets du <img src="/assets/img/logos/teranga.png" className="teranga_img"/>  sur la plante :</b></p>
                              <p className=" titre_teranga"><img src="/assets/img/logos/teranga.png" className="teranga_img"/> a une action indirecte sur le développement des plantes en créant toutes les conditions propices à leur plein épanouissement :</p>
                            <p><i className="fa fa-check-circle"></i>Augmente l’enracinement,</p>
                            <p><i className="fa fa-check-circle"></i>Renforce les défenses naturelles,</p>
                            <p><i className="fa fa-check-circle"></i>Limite la pression fongique</p>
                            <p><i className="fa fa-check-circle"></i>Permet une nutrition équilibrée, complète et progressive</p>
                            </Fade>
                          </div>
                         
                          </div>


                          <div className="row sol">
                          
                         <div className="col-md-7">
                                  
                                <Fade left>
                                <p><span className="alignation"><b>Effets du <b className="keywords"><img src="/assets/img/logos/teranga.png" className="teranga_img"/></b> sur l’environnement :</b></span></p>
                                <p><span className="alignation"><img src="/assets/img/logos/teranga.png" className="teranga_img"/> bénéficie d’un contrôle strict des matières premières servant à sa fabrication et en particulier des métaux lourds.</span></p>
                          <p><i className="fa fa-check-circle"></i><span className="alignation">Le mode d’action des éléments contenus dans le <img src="/assets/img/logos/teranga.png" className="teranga_img"/> permet de réduire les pertes par lessivage et les pertes par volatilisation dans l’air. Il augmente la capacité des plantes à capter le CO2 présent dans l’air.</span></p>
                          <p><i className="fa fa-check-circle"></i><span className="alignation">L’apport de <img src="/assets/img/logos/teranga.png" className="teranga_img"/>  permet d’augmenter de façon significative l’activité biologique d’un sol, de favoriser les échanges sol/plante et de réduire les phénomènes de parasitisme.</span></p>
                          <p><span className="alignation"><img src="/assets/img/logos/teranga.png" className="teranga_img"/> est utilisé en Agriculture Biologie et en conventionnelle avec : </span></p>
                          <p><i className="fa fa-check-circle"></i>Taux de matières organiques d’origine végétale élevé, donc humifiable.</p>
                          <p><i className="fa fa-check-circle"></i>Absence de pathogènes, de graines et de mauvaises herbes</p>
                          <p><i className="fa fa-check-circle"></i>Application mécanique facilitée par sa forme granulée</p>
                          <p><i className="fa fa-check-circle"></i>Valorisation et rentabilité de la dépense minérale</p>
                            </Fade>
                          </div>
                          <div className="col-md-5">
                            <Fade left>
                            <img src="/assets/img/images/branding/pmg5.jpg" className="images_sol"/>
                            </Fade>
                        </div>
                          </div>




                        </div>

                     
                     </div>
                      </div>
                      
                      

                     
              
                     </div>
                     </div>
            </div>
           
              
            

        </section>
<hr />


<StyleRoot>

      <Modal
        size="lg" 
        show={this.state.SmShow}
        onHide={() => this.setSmShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        style={styles.zoomInDown}
      >
        <div className="" style={styles.zoomInDown}>
        <Modal.Header closeButton>
       
        <h4>Notre amendement <b className="keywords"><img src="/assets/img/logos/teranga.png" className="teranga_img"/></b> est disponible</h4>

          <Modal.Title id="example-modal-sizes-title-lg">

          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="">
                          <div className="col-md-12">
                                
                                <img src="/assets/img/images/branding/bat_sac_amendement.jpg" className="amendement_img"/>

                                  <p><i className="fa fa-check-circle"></i>Green Agro Business propose des solutions <img src="/assets/img/logos/teranga.png" className="teranga_img"/> et <img src="/assets/img/logos/terangaplus.png" className="page_ter_plus"/> naturelles pour une agriculture saine et durable.</p>
                                      <p>Fabriquées et commercialisées au Sénégal, ces solutions s’alignent avec l’Etat du Sénégal dans la contribution du volet agricole du Plan Sénégal Emergent (PSE) et de l’auto-suffisance alimentaire.</p>
                                      <p>Green Agro Business est engagée dans une démarche qualité en phase avec les normes du Sénégal et de la CEDEAO afin de garantir une agriculture biologique et d’accompagner les producteurs dans l’amélioration de leurs rendements et la régénération des sols.</p>
                                      <p>Pour toute commande et demande d’informations merci de nous contacter au: </p>
                                      <p> Téléphone fixe :<b className="keywords"> + 221 33 825 74 44 </b></p>
                                  <p>Téléphone mobile :<b className="keywords">+221 76 013 88 88</b></p>
                                  <p>Email : <b className="keywords">contact@greenagrobusiness.com</b></p>
                                  <p>Site : <b className="keywords">www.greenagrobusiness.com</b></p>
                                  <p>Contact Niayes :<b className="keywords">+221 76 224 30 44</b></p>
                                  <p>Contact Nord :<b className="keywords">+221 76 224 30 45</b></p>
                                  <p>Green Agro Business Keur Moussa-Région de Thiès-SENEGAL</p>
                                
                          </div>
                      
                          </div>

        </Modal.Body>
        </div>
      </Modal>
     
      </StyleRoot>


    </div>
       
        

    )
  }
}
export default TERANGA;


// WEBPACK FOOTER //
// ./src/components/teranga.jsx